<template>
  <div v-if="impersonation" class="impersonation-banner" role="status" aria-label="Impersonation mode">
    <span class="impersonation-badge">Impersonation mode</span>
    <span class="impersonation-text">
      <strong>{{ byLabel }}</strong> is viewing as <strong>{{ currentLabel }}</strong>
    </span>
    <button type="button" class="impersonation-exit" @click="exit">
      Exit impersonation
    </button>
  </div>
</template>

<script>
import { getImpersonation, exitImpersonation } from '@/helpers/impersonation';

export default {
  name: 'ImpersonationBanner',
  data() {
    return {
      impersonation: getImpersonation(),
    };
  },
  computed: {
    byLabel() {
      const by = (this.impersonation && this.impersonation.by) || {};
      let label = by.name || by.email || 'An admin';
      if (by.role) {
        label += ` (${by.role})`;
      }
      return label;
    },
    currentLabel() {
      const user = this.safeParse(localStorage.getItem('user'));
      const role = this.safeParse(localStorage.getItem('role'));
      const company = this.safeParse(localStorage.getItem('company'));
      let label = user.name || user.email || 'Unknown user';
      const details = [user.email !== label ? user.email : null, role.name, company.name]
        .filter(Boolean)
        .join(' · ');
      if (details) {
        label += ` (${details})`;
      }
      return label;
    },
  },
  mounted() {
    if (this.impersonation) {
      document.body.classList.add('impersonation-active');
    }
  },
  beforeDestroy() {
    document.body.classList.remove('impersonation-active');
  },
  methods: {
    safeParse(value) {
      try {
        return JSON.parse(value || 'null') || {};
      } catch (e) {
        return {};
      }
    },
    exit() {
      // Exiting does a full page load; guard against losing unsaved work,
      // since this banner (and button) is present on every page.
      if (!window.confirm('Exit impersonation? Any unsaved changes on this page will be lost.')) {
        return;
      }
      exitImpersonation();
    },
  },
};
</script>

<style>
  /* Not scoped: also offsets the fixed CoreUI header and sidebar so the
     top-docked banner never covers them. */
  body.impersonation-active {
    padding-top: 44px;
  }
  body.impersonation-active .c-header.c-header-fixed {
    top: 44px;
  }
  body.impersonation-active .c-sidebar {
    top: 44px;
  }
  .impersonation-banner {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    height: 44px;
    z-index: 2050; /* above CoreUI header (1030) and modals backdrop area */
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 0 16px;
    overflow: hidden;
    background: #f59e0b;
    color: #1f1300;
    font-size: 0.9rem;
    line-height: 1.35;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);
  }
  .impersonation-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .impersonation-badge {
    background: #1f1300;
    color: #fbbf24;
    font-size: 0.68rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    border-radius: 999px;
    padding: 3px 10px;
    white-space: nowrap;
  }
  .impersonation-text strong {
    font-weight: 700;
  }
  .impersonation-exit {
    border: 1.5px solid #1f1300;
    background: transparent;
    color: #1f1300;
    font-weight: 700;
    font-size: 0.82rem;
    border-radius: 8px;
    padding: 4px 12px;
    cursor: pointer;
    white-space: nowrap;
  }
  .impersonation-exit:hover {
    background: #1f1300;
    color: #fbbf24;
  }
  @media (max-width: 576px) {
    .impersonation-banner {
      font-size: 0.8rem;
      padding: 7px 10px;
    }
  }
</style>
